import React from "react";
import { getSpotifyRouteFromURL } from "../library/SpotifyHelper";

function SpotifyEmbed({ url }) {
  const route = getSpotifyRouteFromURL(url);
  const embedUrl = `https://open.spotify.com/embed${route}`;
  return (
    <iframe
      style={{ borderRadius: 12 }}
      src={embedUrl}
      width="100%"
      height="352"
      frameBorder="0"
      allowfullscreen=""
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    />
  );
}

export default SpotifyEmbed;
